<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.assignPatients.nutritionistSelector')"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">
        <search-input
          ref="foodSearch"
          class="search-input"
          :focus="true"
          v-on:input="onChangeFilter"/>
        <div
          class="margin-top-xl food-list">
          <h3
            class="margin-bottom-l">
            {{ $t('health.assignPatients.nutritionists') }}
          </h3>
          <radio
            v-for="(nutri, index) in getFilteredNutris.slice(0, maxNutrisToShow)"
            :key="index"
            v-on:change="onVariableSelected(nutri)"
            :checked="isChecked(nutri)"
            radio-size="s"
            :id="String(nutri.id)"
            :label="nutri.username"/>
          <div
            v-if="getFilteredNutris.length > maxNutrisToShow"
            class="and-x-more">
            {{ $t('variables.andXMore', {count: nutrisToShow()}) }}
          </div>
        </div>
      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Radio from '@/components/shared/forms/Radio';

export default {
  name: 'AssignNutriModal',
  components: {
    OkCancelModal,
    SearchInput,
    Radio
  },
  props: {
    nutritionists: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      usernameFilter: '',
      selectedNutri: undefined,
      maxNutrisToShow: 50
    };
  },
  computed: {
    getFilteredNutris () {
      if (this.usernameFilter !== '') {
        return this.nutritionists.filter(nutri => {
          return replaceSpecialChars(nutri.username.toUpperCase()).includes(replaceSpecialChars(this.usernameFilter.toUpperCase()));
        });
      }
      return this.nutritionists;
    }
  },
  methods: {
    isChecked (food) {
      return this.selectedNutri !== undefined &&
      this.selectedNutri !== null &&
      this.selectedNutri.id === food.id ? 'checked' : '';
    },
    onVariableSelected (nutri) {
      this.selectedNutri = nutri;
    },
    onOk () {
      this.$emit('input', this.selectedNutri);
      this.$emit('close');
    },
    onChangeFilter (filter) {
      this.usernameFilter = filter;
    },
    nutrisToShow () {
      return this.getFilteredNutris.length - this.maxNutrisToShow;
    }
  }
};

const replaceSpecialChars = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

h3 {
  color: $jamaicol;
}

.food-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

.and-x-more {
  color: $jamaicol;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/patients/AssignNutriModal.vue